var PaymentSubmissionMethod = {
  POST_FORM: 'POST_FORM',
  REDIRECT_URL: 'REDIRECT_URL',
  NONE: 'NONE'
}

export { PaymentSubmissionMethod }
